import React from "react";

import { NewsListField, NewsItemField } from '../../Utilities/Enums/ParametersEnum';
import { ViewType } from '../../Utilities/Enums/ViewTypeEnum';
import { ActiveStatusEnum } from '../../Utilities/Enums/StatusEnums';

export class NewsItem {
    [NewsItemField.NAME]?: string = "";
    [NewsItemField.DATE]?: string | Date | null = null;
    [NewsItemField.DESCRIPTION]?: any = "";
    [NewsItemField.COVER_IMAGE]?: any = "";
    [NewsItemField.COVER_IMAGE_SRC]?: any = "";
    [NewsItemField.CREATED_BY_NAME]?: string = "";
    [NewsItemField.HAS_COVER_IMAGE]?: boolean = false;
    [NewsItemField.IS_COVER_CHANGE]?: boolean = false;
    [NewsItemField.STATUS]?: ActiveStatusEnum = ActiveStatusEnum.ACTIVE;
    [NewsItemField.PUBLIC_ID]?: string | number = "";

    constructor(obj?: Partial<NewsItem>) {
        Object.assign(this, obj);
    }
}

export class NewsList {
    [NewsListField.COVER_IMAGE_URL]?: string = "";
    [NewsListField.COVER_IMAGE_SRC]?: string = "";
    [NewsListField.CREATED_BY_NAME]?: string = "";
    [NewsListField.DATE]?: string | Date | null = null;
    [NewsListField.DESCRIPTION]?: string = "";
    [NewsListField.HAS_COVER_IMAGE]?: boolean = false;
    [NewsListField.NAME]?: string = "";
    [NewsListField.PUBLIC_ID]?: string | number = "";
    [NewsListField.UPDATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<NewsList>) {
        Object.assign(this, obj);
    }
}

export class AddEditViewNewsModalInterface {
    openAddEditViewNewsModal?: boolean;
    setopenAddEditViewNewsModal?: React.Dispatch<React.SetStateAction<boolean>>;
    viewType?: ViewType;
    setviewType?: React.Dispatch<React.SetStateAction<ViewType>>;
    newsPublicId?: string | number | null = "";
    setnewsPublicId?: React.Dispatch<React.SetStateAction<string | number | null>>;
    // companyPublicId?: string | number;
    // getCompanyData?: () => void = () =>{};


    constructor(obj?: Partial<AddEditViewNewsModalInterface>) {
        Object.assign(this, obj);
    }
}